import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MaterialModule } from './shared/material-modules';
import { SharedModule } from './shared/shared.module';

const routes: Routes = [{
    path: '',
    loadChildren: () =>
    import('./pages/landing/landing.module').then(
        (m) => m.LandingModule,
    ),
},
{
    path: 'agenda',
    loadChildren: () =>
        import('./pages/agenda/agenda.module').then(
            (m) => m.AgendaModule,
        ),
},
{
    path: 'nieuws',
    loadChildren: () =>
        import('./pages/news/news.module').then(
            (m) => m.NewsModule,
        ),
},
{
    path: 'info',
    loadChildren: () =>
        import('./pages/info/info.module').then(
            (m) => m.InfoModule,
        ),   
},
{
    path: 'kaarten',
    loadChildren: () =>
        import('./pages/ticket/ticket.module').then(
            (m) => m.TicketModule,
        ),    
},];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
